import { buttonClassNames } from '@components/primitives/Button'
import { IconPrefix } from '@components/primitives/Icon/IconPrefix'
import Link from '@components/primitives/Link'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faMicroscope } from '@fortawesome/pro-regular-svg-icons/faMicroscope'
import Routes from '@lib/routes'
import { slide1 } from '@modules/images/pages/for-research-coordinators'

export const ExploreTrialsPanel = ({ treatment }: { treatment: string }) => {
  return (
    <div className={`flex flex-col lg:grid lg:grid-cols-2`}>
      <div className='grid grid-cols-1 gap-4 rounded-xl bg-black p-12 md:rounded-l-xl md:rounded-r-none lg:text-left'>
        <Text
          className='text-white'
          styleName='h3'
          value={`Have you considered ${treatment} clinical trials? `}
        />
        <Text
          className='text-light'
          styleName='h5'
          value={`We made a collection of clinical trials featuring ${treatment}, we think they might fit your search criteria.`}
        />
        <Link
          className={classMerge(
            buttonClassNames.legacy.fill.white,
            'rounded-full',
          )}
          href={Routes.nearMe}
        >
          <IconPrefix icon={faMicroscope}>Go to Trials</IconPrefix>
        </Link>
      </div>
      <div className='col-span-1 hidden h-full lg:block'>
        <div className='relative size-full overflow-hidden rounded-r-xl'>
          <CloudflareImage
            alt={`Explore trials for ${treatment}`}
            className='w-full rounded-r-xl object-fill'
            height={470}
            imageId={slide1}
            width={436}
          />
        </div>
      </div>
    </div>
  )
}
